import { DecimalPipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { FiltreAccueilPeriode } from '../../../FiltreAccueilPeriode';
import { MotifRetourDto, RetournerStatistiquesPodiumMotifsRetoursResultat } from '../../../RetournerStatistiquesPodiumMotifsRetoursResultat';
import { EFactVenteService } from '../../../val-efact-vente.service';
import { CarteDashboardComponent } from '../../carte-dashboard/carte-dashboard.component';

// Panel du top 3 des motifs de retours dans le cycle de vie
@Component({
	selector: 'val-carte-podium-motifs-retours',
	imports: [
		TranslocoModule,
		CarteDashboardComponent,
		DecimalPipe
	],
	templateUrl: './carte-podium-motifs-retours.component.html',
	styleUrl: './carte-podium-motifs-retours.component.scss'
})
export class CartePodiumMotifsRetoursComponent implements OnInit, OnChanges {

	constructor(private eFactVenteService: EFactVenteService) {
		this.filtrePeriode = FiltreAccueilPeriode.TrenteJours;
		this.chargementEnCours = false;
		this.estEnErreur = false;
		this.estVide = false;
		this.donnees = null;
	}

	// Période sélectionnée dans le filtre temporel
	@Input()
	public filtrePeriode: FiltreAccueilPeriode;

	// Indique si le chargement des données est en cours
	public chargementEnCours: boolean;

	// Indique si le dernier chargement s'est soldé par une erreur
	public estEnErreur: boolean;

	// Indique si le chargement a réussi mais qu'aucun motif de retour n'est à afficher
	public estVide: boolean;

	// Données du panel
	public donnees: RetournerStatistiquesPodiumMotifsRetoursResultat | null;

	// Retourne les motifs dans l'ordre d'affichage podium : rang 2 (gauche), rang 1 (centre), rang 3 (droite)
	public get motifsOrdonnesPodium(): MotifRetourDto[] {
		if (!this.donnees?.motifsRetour) return [];
		return [2, 1, 3]
			.map(rang => this.donnees!.motifsRetour.find(m => m.rang === rang))
			.filter((m): m is MotifRetourDto => m !== undefined);
	}

	public async ngOnInit(): Promise<void> {
		await this.chargerDonnees();
	}

	public async ngOnChanges(changes: SimpleChanges): Promise<void> {
		if (changes['filtrePeriode'] && !changes['filtrePeriode'].firstChange)
			await this.chargerDonnees();
	}

	private async chargerDonnees(): Promise<void> {
		this.chargementEnCours = true;
		this.estEnErreur = false;
		this.estVide = false;
		this.donnees = null;

		try {
			const resultat = await this.eFactVenteService.RetournerStatistiquesPodiumMotifsRetours(this.filtrePeriode);
			if (resultat.status === 'success' && resultat.resultat) {
				this.donnees = resultat.resultat;
				this.estVide = this.donnees.motifsRetour.length === 0;
			} else {
				this.estEnErreur = true;
			}
		} catch {
			this.estEnErreur = true;
		} finally {
			this.chargementEnCours = false;
		}
	}
}